import { Card, Table } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import styled from "styled-components";
import "./studentLop.css";
import LineGraph from "Pages/StudentPortfolio/StudentLOPSection/LineGraph";
import { returnRiskSegment } from "Pages/BranchHealth/BranchHealthTable";
// import BarGraph from "Pages/BranchHealth/Student/BarGraph";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;
export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
interface IStudentLopTable {
  searchedFaculty?: any;
  mode?: string;
  tableloading?: any;
  tableData?: any;
  filterState?: any;
  barArray?: any;
  tableHeading?: any;
  barData?: any;
  barLabel?: any;
}
const StudentLopTable = ({
  tableHeading,
  tableData,
  barArray,
}: IStudentLopTable) => {
  const renderColumn = (item: any, column: any) => {
    switch (column.value) {
      case "month":
        return (
          <td className="border text-center">
            <strong className="monthCamelCase">
              {item[column.value].split("_")[0].substring(0, 3)}
              {"'"}
              {item[column.value].split("_")[1]}
            </strong>
          </td>
        );
      case "segment":
        return (
          <td className="border text-center">
            <div className="w-100 d-flex justify-content-center">
              {returnRiskSegment(item[column.value])}
            </div>
          </td>
        );
      default:
        return <td className="border text-center">{item[column.value]}</td>;
    }
  };
  return (
    <div className="m-0 overflow-auto">
      <Card className="mb-0">
        <div className="tableFixHead">
          {tableData && tableData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="No data present"
                secondaryMessage={
                  "There is either no data available or the system is currently in the process of syncing data."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <div className="d-flex flex-column mainContainerForGraphTable">
              <div className="graphHeightBarDV">
                <LineGraph linedata={tableData} barArray={barArray} />
              </div>
              <Table
                responsive
                className="table table-hover tableSideHead tableBodyMain loptablemain"
              >
                <tbody>
                  {tableHeading.map((item: any, index: number) => (
                    <tr key={index}>
                      {tableData.map((el: any) => renderColumn(el, item))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};
export default StudentLopTable;
